import { render, staticRenderFns } from "./FilesConfiguration.vue?vue&type=template&id=27b8b244&"
import script from "./FilesConfiguration.vue?vue&type=script&lang=ts&"
export * from "./FilesConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports